<div class="testing-map">

    <app-cambodia-map></app-cambodia-map>

</div>


<div class="bottom-content-poster">
    <img src="images/customer_service/customer_service_1.jpg" alt="">
    <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
</div>
